var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EAEEFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.666 18.9997C15.666 18.0792 16.4122 17.333 17.3327 17.333H26.4993C29.721 17.333 32.3327 19.9447 32.3327 23.1663V28.8924C32.3327 29.4119 31.9116 29.833 31.3921 29.833H30.6365C30.4343 31.2465 29.2187 32.333 27.7493 32.333C26.28 32.333 25.0644 31.2465 24.8622 29.833H22.3031C22.101 31.2465 20.8854 32.333 19.416 32.333C18.2087 32.333 17.1728 31.5995 16.7295 30.5538C16.1072 30.3121 15.666 29.7074 15.666 28.9997V25.6663V23.9997V18.9997ZM22.052 28.1663H25.1134C25.4015 27.5598 25.8928 27.0685 26.4993 26.7804V25.6663H17.3327V27.3751C17.8621 26.8349 18.5999 26.4997 19.416 26.4997C20.5795 26.4997 21.5839 27.1809 22.052 28.1663ZM26.4993 29.4163C26.4993 30.1067 27.059 30.6663 27.7493 30.6663C28.4397 30.6663 28.9993 30.1067 28.9993 29.4163C28.9993 28.726 28.4397 28.1663 27.7493 28.1663C27.059 28.1663 26.4993 28.726 26.4993 29.4163ZM17.3327 23.9997H26.4993L26.4993 18.9997L17.3327 18.9997V23.9997ZM28.166 26.5292C29.1492 26.6698 29.9741 27.3008 30.3853 28.1663H30.666V23.9997H28.166V26.5292ZM28.166 22.333H30.5827C30.3101 20.9902 29.3918 19.8819 28.166 19.3464V22.333ZM19.416 28.1663C18.7257 28.1663 18.166 28.726 18.166 29.4163C18.166 30.1067 18.7257 30.6663 19.416 30.6663C20.1064 30.6663 20.666 30.1067 20.666 29.4163C20.666 28.726 20.1064 28.1663 19.416 28.1663Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxDrive);
export default __webpack_public_path__ + "static/media/inbox_drive.efd7387ba3d415f737fc54141d8c5c57.svg";
export { ForwardRef as ReactComponent };